import { i18n } from "translate/i18n";

export const pullGooglePic = i18n.t("messages.pullGooglePic");
export const pullFacebookPic = i18n.t("messages.pullFacebookPic");
